<template>
  <div class="page flex-col">
    <div class="group_4 flex-col">
      <span class="text_7">华为云创新中心</span>
      <span class="text_8">160+创新中心，提供企业数字化转型公共服务平台支持</span>
      <div class="text-wrapper_1 flex-col"><span class="text_9">联系我们</span></div>
    </div>
    <span class="text_10">华为云创新中心，加速地方产业转型升级</span>
    <div class="group_5 flex-row justify-end">
      <div class="text-wrapper_20 flex-col">
        <span class="text_11">打通供给需求实时对接，激活地方产业创新升级</span>
        <span class="paragraph_1">
          华为云创新中心基于云基础设施，整合数字经济生态资源，以提供技术解决方案、行业数字
          <br />
          化转型实践服务的“1+3”融通创新体系，通过技术赋能和商业赋能两个层面，为政府、中小
          <br />
          企业与生态伙伴创新需求，加速融通创新
        </span>
        <span class="text_12">“1+3”融通创新体系</span>
        <span class="paragraph_2">
          •&nbsp;融通创新公共服务平台:提供关平数字生态的各个环节的、一整套的技术赋能方案
          <br />
          •&nbsp;服务中心:坚持本地化运营，服务本地一站式行业转型与中小企业发展
          <br />
          •&nbsp;能力中心:以技术为核心，面向区域数字化转型提供全栈技术服务
          <br />
          •&nbsp;生态中心:携手伙伴进行技术赋能和商业加速，繁荣本地产业生态
        </span>
      </div>
      <div class="group_6 flex-col"></div>
    </div>
    <div class="list_2 flex-row">
      <div class="text-wrapper_3 flex-col" v-for="(item, index) in loopData0" :key="index">
        <span class="text_13" v-html="item.lanhutext0"></span>
      </div>
    </div>
    <span class="text_17">产品与服务</span>
    <div class="section_4 flex-row justify-between">
      <div class="group_9 flex-col">
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng8943d2d7a2ec32ed78dab5e63d0917d1dd0fcb0d3c3be7de1b41968b343c5ea4.png"
        />
        <div class="text-group_11 flex-col justify-between">
          <span class="text_18">标准版</span>
          <span class="text_19">数智通衢&nbsp;彩“云”之南</span>
        </div>
        <div class="text-wrapper_7 flex-col"><span class="text_20">查看详情</span></div>
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngd423b18a224d17a556a80aadcb3a8bf761c7b058cfbe3c013d9d67edbabd95ba.png"
        />
      </div>
      <div class="section_2 flex-col">
        <img
          class="image_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng8943d2d7a2ec32ed78dab5e63d0917d1dd0fcb0d3c3be7de1b41968b343c5ea4.png"
        />
        <div class="text-group_12 flex-col justify-between">
          <span class="text_42">高级版</span>
          <span class="text_43">数智通衢&nbsp;彩“云”之南</span>
        </div>
        <div class="text-wrapper_15 flex-col"><span class="text_44">查看详情</span></div>
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4262dbf058d0e8890911899119c559b13875107f0e110eb598a194649e2d0980.png"
        />
      </div>
      <div class="section_3 flex-col">
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng8943d2d7a2ec32ed78dab5e63d0917d1dd0fcb0d3c3be7de1b41968b343c5ea4.png"
        />
        <div class="text-group_13 flex-col justify-between">
          <span class="text_45">顶级版</span>
          <span class="text_46">数智通衢&nbsp;彩“云”之南</span>
        </div>
        <div class="text-wrapper_16 flex-col"><span class="text_47">查看详情</span></div>
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngd438dfdaa8969be7cb70d8261772d5d518207f89c34f26f6f4ce904d92f83d59.png"
        />
      </div>
    </div>
    <span class="text_26">功能介绍</span>
    <div class="text-wrapper_21 flex-row justify-between">
      <span class="text_27">人工智能商城</span>
      <span class="text_28">数字直播</span>
      <span class="text_29">智能客服</span>
      <span class="text_30">AIGC生成图文</span>
      <span class="text_31">数字人定制</span>
    </div>
    <div class="group_12 flex-col"></div>
    <div class="group_13 flex-row justify-end">
      <div class="text-wrapper_22 flex-col justify-between">
        <span class="text_32">数字直播</span>
        <span class="paragraph_3">
          虚拟数字人是系统运用人工智能、大数据、数字技术等通过拟人3D建模创建出来的、与人类形象接近的数字化人物形象。系统利用强大的智能(AI)技术打破物理界限，驱动数字人提供拟人服务和体验是其核心价值。超写实、工具化、强交互是未来数字人智能应用发展的先进趋势。
          <br />
          数字人在企业商业发展类领域中有着重要广泛的应用，主要可以扮演着品牌代言人、客服人员、虚拟商店员工、品牌营销，直播带货、企业培训讲解等各类商业服务角色。随着技术的不断进步，数字人在各个领域的创新应用还将不断增加。企业应用数字人直播或者定制自己的数字人直播将是未来企业发展的必经之路。人工智能商城利用数字人给企业打造属于自己的数字人直播平台，更加形象生动的介绍自己企业的产品和信息，既提升企业宣传形象又节约人力成本，还能获得更多客户关注度。
        </span>
      </div>
      <div class="box_3 flex-col"></div>
    </div>
    <div class="text-group_14 flex-col justify-between">
      <span class="text_33">携手同行</span>
      <span class="text_34">见证产业生态新机遇</span>
    </div>
    <div class="text-wrapper_12 flex-col"><span class="text_35">联系我们</span></div>
    <img
      class="image_2"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng95c3f3d28f29c4780da50790902ffed7ef055560b206e1b3a30365941717962f.png"
    />
    <SiteFooter />
  </div>
</template>
<script>
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: { SiteFooter },
  data() {
    return {
      loopData0: [
        { lanhutext0: '100万+企业用户' },
        { lanhutext0: '2000+合作伙伴' },
        { lanhutext0: '100万+企业用户' },
        { lanhutext0: '20万人才培养' }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="less" src="./assets/index.less" />